<div class="card h-100">
  <div class="card-header bg-light d-flex justify-content-between align-items-center">
    <h4 class="mb-0"><i class="fa fa-map-marker mr-1"></i> Move Location Request Required</h4>
    <button class="btn btn-sm btn-outline-secondary" (click)="loadTasks()">
      <i class="fa fa-refresh"></i>
    </button>
  </div>

  <!-- Loading state -->
  <div *ngIf="loading" class="card-body text-center py-4">
    <i class="fa fa-spinner fa-spin fa-lg text-muted"></i>
    <p class="text-muted mt-2 small">Loading tasks...</p>
  </div>

  <!-- Error state -->
  <div *ngIf="!loading && error" class="card-body bg-light">
    <p class="text-muted text-center small mb-0">Unable to load tasks. Please try again.</p>
  </div>

  <!-- No tasks state -->
  <div *ngIf="!loading && !error && tasks.length === 0" class="card-body text-center py-4">
    <p class="text-muted small mb-0">No open move location requests</p>
  </div>

  <!-- Tasks table -->
  <div *ngIf="!loading && !error && tasks.length > 0" class="card-body p-0">
    <div class="table-responsive">
      <table class="table table-sm table-hover mb-0">
        <thead class="thead-light">
          <tr>
            <th>Created Date</th>
            <th>Account</th>
            <th>Due Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let task of tasks">
            <td class="small">{{ formatDate(task.createdDate) }}</td>
            <td class="small">
              <a href="javascript:void(0)"
                 (click)="onAccountNameClick(task.accountName)"
                 class="text-primary font-weight-bold">
                {{ task.accountName }}
              </a>
            </td>
            <td class="small">{{ formatDate(task.dueDate) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
